module.exports = __webpack_public_path__ + "img/DE00661.2149011c.png";